var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.5 12.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.9,1.9c-.7,0-.9.3-.9,1v1.2h2l-.2,1.9h-1.8v5.9H1.6v-5.9H0v-1.9h1.6v-1.2C1.6,1,2.4,0,4.6,0c.5,0,.9,0,1.4,0v1.8h-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.1,7.8c0-2.2,1-3.8,3.2-3.8s1.9.6,2.2,1.4v-1.2h2.3v7.8h-2.3v-1.2c-.3.8-1.1,1.3-2.2,1.3-2.2,0-3.2-1.6-3.2-3.8v-.5ZM8.4,8.3c0,1.2.4,1.9,1.5,1.9s1.5-.7,1.5-1.8v-.8c0-1.1-.5-1.8-1.5-1.8s-1.5.8-1.5,1.9v.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.7,4c.9,0,1.8.2,2.3.5l-.5,1.7c-.5-.2-1-.4-1.6-.4-1.3,0-1.8.7-1.8,2v.5c0,1.3.6,2,1.8,2,.5,0,1.1-.1,1.6-.4l.5,1.7c-.5.3-1.3.5-2.3.5-2.8,0-4-1.5-4-3.9v-.4c0-2.4,1.3-3.9,4-3.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.2,8.3v-.7c0-2.2,1.3-3.7,3.8-3.7s3.5,1.5,3.5,3.6v1.2h-5c0,1.1.5,1.5,1.8,1.5s1.8-.2,2.5-.5l.4,1.6c-.6.3-1.9.6-3,.6-3,0-4.1-1.5-4.1-3.8ZM23.6,7.3h2.8v-.2c0-.9-.3-1.5-1.4-1.5-1.1,0-1.5.7-1.5,1.7h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.3,8.3c0,2.2-1,3.8-3.2,3.8s-2-.6-2.3-1.3v1.2h-2.2V.2L31.9,0v5.2c.3-.7,1.1-1.2,2.2-1.2,2.2,0,3.2,1.6,3.2,3.8v.5ZM34.9,7.7c0-1.1-.4-1.9-1.6-1.9s-1.5.7-1.5,1.8v.8c0,1.1.5,1.8,1.5,1.8s1.6-.8,1.6-1.9v-.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38,8.2v-.4c0-2.2,1.3-3.9,3.9-3.9s3.9,1.6,3.9,3.9v.4c0,2.2-1.3,3.9-3.9,3.9s-3.9-1.6-3.9-3.9ZM43.4,7.7c0-1-.4-1.8-1.5-1.8s-1.5.8-1.5,1.8v.7c0,1,.4,1.8,1.5,1.8s1.5-.8,1.5-1.8v-.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.6,8.2v-.4c0-2.2,1.3-3.9,3.9-3.9s3.9,1.6,3.9,3.9v.4c0,2.2-1.3,3.9-3.9,3.9s-3.9-1.6-3.9-3.9ZM52,7.7c0-1-.4-1.8-1.5-1.8s-1.5.8-1.5,1.8v.7c0,1,.4,1.8,1.5,1.8s1.5-.8,1.5-1.8v-.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.6,7.8l2.3-3.7h2.5l-2.4,3.8,2.5,3.9h-2.5l-2.4-3.8v3.8h-2.4V.2l2.4-.2v7.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebook-dark.eb2f2353de26f13c1a882bc7931c23f0.svg";
export { ForwardRef as ReactComponent };